// extracted by mini-css-extract-plugin
module.exports = {"signUp":"SignUp_signUp__1-UxY","container1":"SignUp_container1__3wrGc","names":"SignUp_names__UBJbb","inputBase":"SignUp_inputBase__3Ypaq","additional":"SignUp_additional__Vg1aF"};